import { useEffect, useRef } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL, doesRoleExist, handleNotOkHttpResponse } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Preloader from "../common/Preloader";

function FarmerTable() {
    const { user } = useAuth();
    const [farmers, setFarmers] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const [showPreloader, setShowPreloader] = useState(false);
    const [show, setShow] = useState(false);
    const [selectedFarmerId, setSelectedFarmerId] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "Edit",
            icon: "icon-edit1",
            routerPath: "/outgrower/edit",
        },
        {
            id: 2,
            name: "Farms",
            icon: "icon-developer_board",
            routerPath: "/farms/farmer",
        }

        // {
        //     id: 3,
        //     name: "Delete",
        //     icon: "flaticon-transfer-1",
        //     onClick: (process) => {
        //         handleShow(process.id)
        //     },
        // }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        if (farmers && farmers.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        // { width: "4%", targets: 0 },
                        // { width: "12%", targets: 2 } 
                    ]
                });
            });
        }
    }, [farmers]);
    useEffect(() => {
        const fetchFarmers = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
                toast.warn("You seem to have lost your access token. Please try again later.");
                return;
            }
            setShowPreloader(true);
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user.user.token}`,
                    }
                };
                const response = await fetch(`${baseURL}/farmers`, requestOptions);
                if (!response.ok) {
                    throw new Error('Error fetching farmers');
                }
                const data = await response.json();
                setFarmers(data);
            } catch (error) {
                toast.error("Error fetching farmers.");
                console.error("Error fetching farmers:", error);
            } finally {
                setShowPreloader(false);
            }
        };
        fetchFarmers();
    }, []);


    const handleShow = (processId) => {
        setShow(true);
        setSelectedFarmerId(processId);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedFarmerId(null);
    };

    const handleRemoveFarmer = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        setShowPreloader(true);
        try {

            if (!selectedFarmerId) {
                console.error('No selected Services Provider ID');
                return;
            }

            const data = {
                id: selectedFarmerId,
            }
            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
                body: JSON.stringify(data)
            };

            const response = await fetch(`${baseURL}/farmers/${selectedFarmerId}`, requestOptions);
            if (response.ok) {
                toast.success("Farmer removed successfully");
                setShowPreloader(true);
                handleClose();
                window.location.reload();

            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Farmer:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };

    return (
        <>
            <Preloader show={showPreloader} />
            <div className="main-container">

                <div className="row gutters">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">List of Outgrowers</div>
                                {/* <div className="mt-3 p-2 parentLabel">
                                    <div className="mt-2 mb-1">
                                        <span>Field: </span>{fieldName}
                                    </div>
                                </div>
                                <br/> */}
                                {doesRoleExist(user, "Admin") && (
                                    <Link to={`/outgrower/create`} className="btn btn-primary float-end">
                                        <i className="icon-add"></i> Add Outgrower
                                    </Link>
                                )}
                            </div>
                            <div className="card-body pt-0">
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        
                                            <div className="table-responsive" style={{minHeight: "700px"}}>
                                                <table id="data-table" className="table custom-table">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th>Unique Code</th>
                                                            <th>GLN</th>
                                                            <th>First Name</th>
                                                            <th>Last Name</th>
                                                            <th>Gender</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email</th>
                                                            <th>Started Year Of Farming</th>
                                                            <th>Home Address</th>
                                                            <th><div className="float-end">Actions</div></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {farmers && farmers.length > 0 ? farmers.map((farmer, index) => (
                                                            <tr key={index}>
                                                                <td>{farmer.code ? farmer.code : '--'}</td>
                                                                <td>{farmer.gln ? farmer.gln : '--'}</td>
                                                                <td>{farmer.firstName}</td>
                                                                <td>{farmer.lastName}</td>
                                                                <td>{farmer.gender}</td>
                                                                <td>{farmer.mobileNumber}</td>
                                                                <td>{farmer.email}</td>
                                                                <td>{farmer.startingYearOfFarming}</td>
                                                                <td>{farmer.homeAddress}</td>
                                                                <td className="">
                                                                    <ul>
                                                                        <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                                            <div className="dropdown">
                                                                                <Link
                                                                                    className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                                    role="button"
                                                                                    to="#"
                                                                                    id={"dropdownMenuLink" + farmer.id}
                                                                                    data-bs-toggle="dropdown"
                                                                                >
                                                                                    Actions <i className="fa fa-caret-down"></i>
                                                                                </Link>
                                                                                <ul
                                                                                    className="dropdown-menu"
                                                                                    aria-labelledby={"dropdownMenuLink" + farmer.id}
                                                                                >
                                                                                    {profileMenuItems.map((actionMenuItem) => (
                                                                                        <li key={farmer.id + '-' + actionMenuItem.id}>
                                                                                            {actionMenuItem.onClick ? (
                                                                                                <Link
                                                                                                    to="#"
                                                                                                    className="dropdown-item"
                                                                                                    onClick={(e) => {
                                                                                                        e.preventDefault(); // Prevent default anchor behavior
                                                                                                        actionMenuItem.onClick(farmer);
                                                                                                    }}
                                                                                                    style={
                                                                                                        isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                            ? { color: "#ff5a5f" }
                                                                                                            : undefined
                                                                                                    }
                                                                                                >
                                                                                                    <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;
                                                                                                    <span dangerouslySetInnerHTML={{ __html: actionMenuItem.name }}></span>
                                                                                                </Link>
                                                                                            ) : (
                                                                                                <Link
                                                                                                    to={actionMenuItem.routerPath + "/" + farmer.id} // Changed href to to
                                                                                                    className="dropdown-item"
                                                                                                    style={
                                                                                                        isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                            ? { color: "#ff5a5f" }
                                                                                                            : undefined
                                                                                                    }
                                                                                                >
                                                                                                    <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;
                                                                                                    <span dangerouslySetInnerHTML={{ __html: actionMenuItem.name }}></span>
                                                                                                </Link>
                                                                                            )}
                                                                                        </li>
                                                                                    ))}

                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                                    </tbody>
                                                </table>
                                                <Modal show={show} onHide={handleClose}>
                                                    <Modal.Header closeButton style={{ backgroundColor: 'rgb(36, 50, 74)' }}>
                                                        <Modal.Title style={{ color: 'white' }}>Delete Workflow Process</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p className="mb-4">
                                                            Are you sure you want to delete this workflowprocess?
                                                        </p>
                                                    </Modal.Body>
                                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                                        <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleClose}>
                                                            Cancel
                                                        </Button>
                                                        <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemoveFarmer}>
                                                            Delete
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Row start */}

                {/* Row end */}

            </div>

        </>
    );
}

export default FarmerTable;